import $ from 'jquery';
import carousels from '../framework/carousel';

const SELECTORS = {
  rail: '[data-media-rail]',
  trigger: '[data-media-modal-trigger]',
  modal: '#media-modal',
  embed: '[data-media-modal-embed]',
  title: '[data-media-modal-title]',
  description: '[data-media-modal-description]'
};

const EDGE_TOLERANCE = 2;

const getSlideEdgeState = ($rail) => {
  const slick = $rail.slick('getSlick');

  if (!slick || !slick.$slides || !slick.$slides.length) {
    return {
      atStart: true,
      atEnd: true
    };
  }

  const listRect = slick.$list[0].getBoundingClientRect();
  const firstRect = slick.$slides[0].getBoundingClientRect();
  const lastRect =
    slick.$slides[slick.$slides.length - 1].getBoundingClientRect();

  return {
    atStart: firstRect.left >= listRect.left - EDGE_TOLERANCE,
    atEnd: lastRect.right <= listRect.right + EDGE_TOLERANCE
  };
};

const setArrowState = ($arrow, isDisabled) => {
  $arrow
    .toggleClass('slick-disabled', isDisabled)
    .prop('disabled', isDisabled)
    .attr('aria-disabled', isDisabled ? 'true' : 'false');
};

const updateRailArrows = ($rail) => {
  const slick = $rail.slick('getSlick');

  if (!slick || !slick.$prevArrow || !slick.$nextArrow) {
    return;
  }

  const edgeState = getSlideEdgeState($rail);

  setArrowState(slick.$prevArrow, edgeState.atStart);
  setArrowState(slick.$nextArrow, edgeState.atEnd);
};

const initMediaRails = () => {
  $(SELECTORS.rail).each((index, element) => {
    const $rail = $(element);

    if ($rail.children().length < 2 || $rail.hasClass('slick-initialized')) {
      return;
    }

    carousels(element, {
      autoplay: false,
      dots: false,
      infinite: false,
      speed: 400,
      arrows: true,
      variableWidth: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: true,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            variableWidth: false
          }
        }
      ]
    });

    $rail.find('.slick-prev').attr('aria-label', 'Previous media');
    $rail.find('.slick-next').attr('aria-label', 'Next media');

    $rail.on('afterChange setPosition breakpoint reInit', () => {
      updateRailArrows($rail);
    });

    updateRailArrows($rail);
  });
};

const iframeMarkup = (src, title) =>
  $('<iframe>', {
    src,
    title,
    loading: 'lazy',
    allow:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
    allowfullscreen: true
  });

const initMediaModal = () => {
  const $modal = $(SELECTORS.modal);

  if (!$modal.length) {
    return;
  }

  const $embed = $modal.find(SELECTORS.embed);
  const $title = $modal.find(SELECTORS.title);
  const $description = $modal.find(SELECTORS.description);
  let lastTrigger = null;

  $(document).on('click', SELECTORS.trigger, (event) => {
    event.preventDefault();

    const trigger = event.currentTarget;
    const $trigger = $(trigger);
    const title = $trigger.attr('data-media-title') || '';
    const description = $trigger.attr('data-media-description') || '';
    const embedUrl = $trigger.attr('data-media-embed-url') || '';
    const templateId = $trigger.attr('data-media-template') || '';
    const template = templateId ? document.getElementById(templateId) : null;

    lastTrigger = trigger;
    $embed.empty().removeClass('media-modal__embed--html');
    $title.text(title);
    $description.text(description).toggleClass('u--display-none', !description);

    if (template) {
      $embed.addClass('media-modal__embed--html').html(template.innerHTML);
    } else if (embedUrl) {
      $embed.append(iframeMarkup(embedUrl, title || 'Video'));
    }

    $modal.trigger('modal:show');
  });

  $modal.on('modal:beforeHide', () => {
    $embed.empty().removeClass('media-modal__embed--html');
  });

  $modal.on('modal:afterHide', () => {
    if (lastTrigger) {
      lastTrigger.focus();
    }
  });
};

$(() => {
  initMediaRails();
  initMediaModal();
});
